module.exports = __webpack_public_path__ + "img/partner_4_2x.444d7324.png";